var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoChevrolet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 250,
    height: 120,
    viewBox: "0 65 250 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DFAE53",
    d: "M170.482 117.225h-31.307v-4.924h-29.232v4.924H83.345l-4.709 9.666h30.339v6.992h31.168v-6.992h25.63z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -237.694,
    x2: -208.758,
    y1: -55.765,
    y2: -84.7,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    style: {
      stopColor: "#dfae53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.636,
    style: {
      stopColor: "#e5b863"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.714,
    style: {
      stopColor: "#eec77b"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    style: {
      stopColor: "#f5d28c"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.888,
    style: {
      stopColor: "#f9d896"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fada99"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M124.559 133.883v-21.582h-14.616v4.924H83.345l-4.709 9.666h30.339v6.992z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7E0B7",
    d: "M138.418 113.058v3.411c0 .835.678 1.513 1.513 1.513h29.34l-3.846 7.898a.599.599 0 0 1-.408.253H140.9c-.835 0-1.513.678-1.513 1.514v5.48h-29.656v-5.48c0-.836-.677-1.514-1.513-1.514H79.847l3.847-7.897a.598.598 0 0 1 .408-.254h25.085c.836 0 1.513-.678 1.513-1.513v-3.411h27.718m0-.757H110.7a.756.756 0 0 0-.756.756v3.411a.757.757 0 0 1-.757.756H84.101a1.327 1.327 0 0 0-1.088.681l-4.045 8.305a.435.435 0 0 0 .425.681h28.825c.418 0 .757.338.757.756v5.48c0 .417.338.756.756.756h29.656a.756.756 0 0 0 .756-.756v-5.48c0-.418.34-.756.757-.756h24.117a1.332 1.332 0 0 0 1.089-.682l4.044-8.305a.436.436 0 0 0-.423-.681h-29.795a.758.758 0 0 1-.757-.756v-3.411a.758.758 0 0 0-.757-.755z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M144.216 114.727v-5.41h-39.313v5.41H76.035l-8.429 17.144.357 2.012h36.938v6.8h39.313v-6.8h28.866l9.418-19.156h-38.282zm21.555 12.164h-25.629v6.992h-31.167v-6.992H78.636l4.708-9.666h26.599v-4.924h29.231v4.924h31.308l-4.711 9.666z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -158.182,
    x2: -152.762,
    y1: -79.75,
    y2: -59.524,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    style: {
      stopColor: "#bfc5c8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612,
    style: {
      stopColor: "#bdc3c6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.662,
    style: {
      stopColor: "#9da1a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.715,
    style: {
      stopColor: "#838586"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772,
    style: {
      stopColor: "#6e6f70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    style: {
      stopColor: "#5f6060"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    style: {
      stopColor: "#575757"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#545454"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m173.082 133.883 9.418-19.156-12.018 2.497-4.709 9.665 7.309 6.994z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -188.837,
    x2: -154.958,
    y1: -76.867,
    y2: -76.867,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    style: {
      stopColor: "#95999d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    style: {
      stopColor: "#979a9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#a2a5a6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#a9abab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#abadac"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M144.216 133.883h28.866l.939-1.912-8.248-5.08h-25.631l4.074 6.992z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -201.005,
    x2: -190.769,
    y1: -88.657,
    y2: -78.421,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    style: {
      stopColor: "#abadac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.367,
    style: {
      stopColor: "#a9acab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    style: {
      stopColor: "#9ea1a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608,
    style: {
      stopColor: "#979b9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#95999d"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "m143.08 138.771-2.928-4.888h-15.584v4.888z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -218.063,
    x2: -207.828,
    y1: -78.422,
    y2: -88.657,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    style: {
      stopColor: "#f5f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#f5f9f9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.433,
    style: {
      stopColor: "#f2f0e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    style: {
      stopColor: "#f0eadd"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    style: {
      stopColor: "#efe7d6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#efe6d4"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M124.559 138.771v-4.888h-15.584l-2.928 4.888z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -251.826,
    x2: -255.344,
    y1: -61.407,
    y2: -81.365,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    style: {
      stopColor: "#abadac"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "#a9acab"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    style: {
      stopColor: "#9ea1a3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    style: {
      stopColor: "#979b9e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#95999d"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "m78.636 126.891 4.708-9.666-7.31-2.497-8.48 17.242.406 1.912 10.676-6.991z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -239.453,
    x2: -241.44,
    y1: -83.074,
    y2: -71.801,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.357,
    style: {
      stopColor: "#f5f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.414,
    style: {
      stopColor: "#dfe6e9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    style: {
      stopColor: "#ced7db"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    style: {
      stopColor: "#c3cdd2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679,
    style: {
      stopColor: "#bcc7cc"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#bac5cb"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M67.964 133.883h36.938l4.073-6.992H78.636l-11.081 5.08.409 1.912z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#95999D",
    d: "M124.38 133.883h.378v4.888h-.378z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -235.266,
    x2: -236.715,
    y1: -66.564,
    y2: -58.346,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.101,
    style: {
      stopColor: "#f0f4f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    style: {
      stopColor: "#e2e7e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    style: {
      stopColor: "#cbd0d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    style: {
      stopColor: "#bfc5c8"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M104.902 114.727H76.035l7.31 2.497h26.599l-5.042-2.497z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -167.276,
    x2: -169.009,
    y1: -57.542,
    y2: -67.373,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    style: {
      stopColor: "#bfc5c8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    style: {
      stopColor: "#cbd0d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#e2e7e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.879,
    style: {
      stopColor: "#f0f4f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#f5f9fa"
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M139.175 117.225h31.308l12.018-2.497h-38.284l-5.042 2.497z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M104.902 109.317v5.41l5.041 2.497v-4.922l-5.041-2.985z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABADAC",
    d: "M144.216 114.727v-5.41l-5.041 2.984v4.924l5.041-2.498z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M144.216 114.727v-1.899l-5.041 4.397 5.041-2.498z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -204.421,
    x2: -204.421,
    y1: -58.782,
    y2: -55.797,
    gradientTransform: "matrix(1 0 0 -1 328.98 53.52)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#f5f9fa"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.162,
    style: {
      stopColor: "#f0f4f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    style: {
      stopColor: "#e2e7e8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.552,
    style: {
      stopColor: "#cbd0d3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635,
    style: {
      stopColor: "#bfc5c8"
    }
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M109.943 112.301h29.231l5.041-2.984h-39.313l5.041 2.984z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#95999D",
    d: "M143.459 140.872h-37.8a.947.947 0 0 1-.945-.945v-5.288a.566.566 0 0 0-.567-.566H68.72a1.136 1.136 0 0 1-1.075-.901l-.092-.521a2.876 2.876 0 0 1 .218-1.54l7.761-15.787a1.512 1.512 0 0 1 1.26-.785h27.354a.568.568 0 0 0 .567-.567v-3.897c0-.521.423-.945.945-.945h37.8c.522 0 .945.424.945.945v3.897a.568.568 0 0 0 .567.567h36.77a.62.62 0 0 1 .595.952l-8.75 17.797a1.515 1.515 0 0 1-1.261.785H144.97a.566.566 0 0 0-.567.566v5.288a.945.945 0 0 1-.944.945zm-66.667-25.955a1.139 1.139 0 0 0-.921.573l-7.761 15.787a2.53 2.53 0 0 0-.185 1.306l.092.522a.75.75 0 0 0 .703.589h35.426a.948.948 0 0 1 .945.945v5.288c0 .313.254.565.567.567h37.8a.568.568 0 0 0 .566-.567v-5.288a.95.95 0 0 1 .946-.945h27.354c.384-.024.729-.239.921-.573l8.75-17.797.169.083-.169-.083a.252.252 0 0 0-.256-.406h-36.77a.95.95 0 0 1-.946-.946v-3.897a.566.566 0 0 0-.566-.567h-37.8a.567.567 0 0 0-.567.567v3.897a.948.948 0 0 1-.945.946H76.792z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M67.555 131.971h38.46l-1.113 1.912H67.964l-.409-1.912z",
    opacity: 0.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M108.975 133.883v-6.992l-4.073 5.08v8.712l4.073-6.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M104.902 133.976H68.095a.188.188 0 0 1-.185-.151l-.405-1.814a.192.192 0 0 1 .145-.228c.013-.002.026-.004.04-.004h40.03v.378H67.925l.321 1.437h36.656v.382z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M174.021 131.971h-30.903l1.114 1.912h28.847l.942-1.912z",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M144.232 140.683v-8.712l-4.071-5.08v6.992l4.071 6.8z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M173.082 133.976h-28.85a.188.188 0 0 1 0-.377h28.733l.745-1.438h-32.292a.188.188 0 1 1 0-.377h32.601a.19.19 0 0 1 .168.276l-.94 1.815a.189.189 0 0 1-.165.101z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M143.355 138.771h-37.414l-1.039 1.912h39.313l-.86-1.912z",
    opacity: 0.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#636564",
    d: "M104.902 140.396h39.332v.379h-39.332zM105.941 138.58h37.715v.378h-37.715z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#684511",
    d: "M139.387 134.071h-29.656a.945.945 0 0 1-.945-.945v-5.479a.567.567 0 0 0-.567-.568H79.393a.62.62 0 0 1-.596-.951l4.046-8.305c.252-.465.73-.763 1.258-.787h25.085a.568.568 0 0 0 .568-.567v-3.411c0-.522.423-.944.945-.945h27.718a.948.948 0 0 1 .946.945v3.411c0 .313.254.567.567.567h29.794a.622.622 0 0 1 .594.951l-4.045 8.306a1.501 1.501 0 0 1-1.258.785h-24.117a.57.57 0 0 0-.567.568v5.48a.945.945 0 0 1-.944.945zm-55.286-16.657c-.383.024-.728.24-.917.573l-4.045 8.306a.25.25 0 0 0 .03.355.251.251 0 0 0 .225.052h28.825a.949.949 0 0 1 .946.946v5.48c0 .313.254.566.567.566h29.656a.567.567 0 0 0 .567-.566v-5.48a.948.948 0 0 1 .945-.946h24.117c.384-.022.729-.238.918-.572l4.045-8.306a.252.252 0 0 0-.254-.408h-29.794a.945.945 0 0 1-.945-.945v-3.411a.57.57 0 0 0-.568-.567H110.7a.57.57 0 0 0-.568.567v3.411a.945.945 0 0 1-.945.945H84.101z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#B89A70",
    d: "M140.143 134.166h-31.167a.284.284 0 0 1-.284-.283v-6.71H78.636a.283.283 0 0 1-.284-.282c0-.157.127-.285.284-.285h30.339c.156 0 .283.128.283.285v6.709h30.601v-6.709c0-.157.127-.285.283-.285h25.631c.156 0 .283.128.283.285a.283.283 0 0 1-.283.282h-25.347v6.71a.283.283 0 0 1-.283.283z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoChevrolet);
export default __webpack_public_path__ + "static/media/logo_chevrolet.0a41ff5148274032cd498d18f08529ff.svg";
export { ForwardRef as ReactComponent };